import type { TenantConfig } from '@/types/TenantConfig'

const yellow = '#EDCD1F'
const red = '#E52828'

export const pop: TenantConfig = {
  logo: 'assets/pop/static/logo.png',
  themeOptions: {
    primaryColor: red,
    secondaryColor: yellow,
    footerBackgroundColor: 'black',
    footerTextColor: 'white',
    cartHeaderBackgroundColor: 'black',
    memberLinksColor: red,
    memberLinksColorHover: yellow,
    logoHeight: '60px',
    headerTopBorder: `4px solid ${yellow}`,
    headerBottomBorder: '1px solid #EFEFEF',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/pop/static/completed.png',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
}
